export default __webpack_public_path__ + "static/media/userFriendLiness.80484a53.png";